(function(){
  if (window.__mpnGrid) return; window.__mpnGrid = true;
  (function(){ var l = document.querySelector('#ProductGridContainer link[href*="/mpn-view-toolbar.css"]'), c = l && l.closest('#ProductGridContainer');
    if (c && !document.querySelector('link[data-mpn-keep="mpn-view-toolbar"]')) { var k = l.cloneNode(); k.setAttribute('data-mpn-keep', 'mpn-view-toolbar'); c.parentNode.insertBefore(k, c); } })();
  var d = document.documentElement, K = 'mpnGridPrefsV3', p = {};
  var desk = window.matchMedia('(min-width: 750px)');
  try { p = JSON.parse(localStorage.getItem(K)) || {}; } catch (e) {}
  d.setAttribute('data-mpn-view', p.view === 'product' ? 'product' : 'lifestyle');
  d.setAttribute('data-mpn-cols', p.cols === '1' ? '1' : '2');
  // Petite collection (reglage de la grille, X produits ou moins) : 1 produit par ligne d'office sur mobile,
  // sauf si le visiteur choisit lui-meme 1 ou 2 colonnes sur cette page.
  // Le choix 1/2 colonnes fait sur une petite collection n'est PAS memorise pour les autres collections.
  var tb0 = document.querySelectorAll('.mpn-view-toolbar[data-mpn-small0]');
  var SMALL0 = !!(tb0.length && tb0[tb0.length - 1].getAttribute('data-mpn-small0') === 'true'), pageChoice = false, auto = false, isSmall = SMALL0;
  function applySmall(){
    var g = document.getElementById('product-grid');
    var small = g ? g.getAttribute('data-mpn-small') === '1' : SMALL0;
    isSmall = small;
    if (pageChoice) return;
    if (small) { if (d.getAttribute('data-mpn-cols') !== '1') d.setAttribute('data-mpn-cols', '1'); auto = true; }
    else if (auto) { d.setAttribute('data-mpn-cols', p.cols === '1' ? '1' : '2'); auto = false; }
  }
  applySmall();
  // Vitesse (oct. 2026) : seule la partie mobile de "sizes" change (1 colonne / pleine largeur = 100vw) ; la partie
  // tablette / ordinateur est celle ecrite par Liquid (largeur reelle d'une colonne, plafonnee). Meme valeur pour la
  // photo de la carte (#product-grid .card__media img) et pour les photos du slider : un seul fichier telecharge.
  var TAIL = ', (max-width: 989px)';
  function sizes(){
    var s = d.getAttribute('data-mpn-cols') === '1' ? '(max-width: 749px) 100vw' : '(max-width: 749px) calc((100vw - 36px) / 2)';
    var w = '(max-width: 749px) 100vw';
    document.querySelectorAll('.mpn-slide img, #product-grid .card__media img').forEach(function(i){
      var cur = i.getAttribute('sizes') || '', k = cur.indexOf(TAIL);
      if (k < 0) return;
      var v = (i.closest('.mpn-last-wide, .mpn-feat') ? w : s) + cur.slice(k);
      if (cur !== v) i.setAttribute('sizes', v);
    });
  }
  // Rythme mobile : 1 produit en pleine largeur apres N produits en 2 colonnes (meme regle que la grille Liquid)
  function layout(g){
    g = g || document.getElementById('product-grid');
    if (!g || !g.hasAttribute('data-mpn-feat')) return;
    var every = parseInt(g.getAttribute('data-mpn-feat'), 10) || 0;
    var more = !!g.getAttribute('data-mpn-next');
    var run = 0, last = null;
    [].slice.call(g.children).forEach(function(li){
      if (!li.classList || !li.classList.contains('grid__item')) return;
      if (li.classList.contains('item__push')) { if (run > 0 && run % 2 === 1) run = -1; else if (run !== -1) run = 0; return; }
      var nx = li.nextElementSibling;
      var nextPush = !!(nx && nx.classList && nx.classList.contains('item__push'));
      var feat = every > 0 && run >= every && !nextPush; // jamais 2 pleines largeurs de suite
      li.classList.toggle('mpn-feat', feat);
      li.classList.remove('mpn-last-wide');
      if (feat) run = 0; else run++;
      last = li;
    });
    if (!more && last && !last.classList.contains('mpn-feat') && run > 0 && run % 2 === 1) last.classList.add('mpn-last-wide');
  }
  window.mpnGridLayout = layout;
  var canvas;
  function fitSort(){
    document.querySelectorAll('#FacetSortDrawerForm .facet-filters__sort').forEach(function(s){
      var o = s.options[s.selectedIndex]; if (!o) return;
      var cs = getComputedStyle(s);
      canvas = canvas || document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      ctx.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      var w = Math.ceil(ctx.measureText(o.text.trim()).width + parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0) + 4);
      if (w > 20 && s.style.width !== w + 'px') s.style.setProperty('width', w + 'px', 'important');
    });
  }
  function place(){
    var bars = [].slice.call(document.querySelectorAll('.mpn-view-toolbar'));
    if (!bars.length) return;
    var fc = document.querySelector('.facets-container-drawer');
    var keep = null;
    if (fc) { bars.forEach(function(b){ if (!keep && fc.contains(b)) keep = b; }); }
    if (!keep) keep = bars[bars.length - 1];
    bars.forEach(function(b){ if (b !== keep) b.remove(); });
    if (desk.matches && fc) {
      if (keep.parentNode !== fc) fc.appendChild(keep);
    } else {
      var grid = document.querySelector('#ProductGridContainer .collection');
      if (grid && keep.nextElementSibling !== grid) grid.parentNode.insertBefore(keep, grid);
    }
  }
  // Bouton Filtres de la barre (mobile) : ouvre le tiroir de filtres habituel
  function fsummary(){ return document.querySelector('.facets-container-drawer summary.mobile-facets__open-wrapper') || document.querySelector('summary.mobile-facets__open-wrapper'); }
  function syncFilter(){
    var has = !!fsummary();
    document.querySelectorAll('[data-mpn-filter]').forEach(function(b){ if (b.hidden === has) b.hidden = !has; });
  }
  function sync(){
    applySmall();
    layout();
    syncFilter();
    place();
    fitSort();
    document.documentElement.classList.add('mpn-tb-ready'); /* barre tri / Ambiance / Matière / Filtres en place : on l'affiche d'un coup (plus d'apparition en décalé) */
    document.querySelectorAll('[data-mpn-view-btn]').forEach(function(b){ b.setAttribute('aria-pressed', String(b.getAttribute('data-mpn-view-btn') === d.getAttribute('data-mpn-view'))); });
    document.querySelectorAll('[data-mpn-cols-btn]').forEach(function(b){ b.setAttribute('aria-pressed', String(b.getAttribute('data-mpn-cols-btn') === d.getAttribute('data-mpn-cols'))); });
    sizes();
  }
  function save(){ p = { view: d.getAttribute('data-mpn-view'), cols: (auto || isSmall) ? p.cols : d.getAttribute('data-mpn-cols') }; try { localStorage.setItem(K, JSON.stringify(p)); } catch (e) {} }
  function updatePos(t){
    var s = t.parentNode, w = t.clientWidth || 1;
    var i = Math.round(t.scrollLeft / w);
    var n = parseInt(getComputedStyle(s).getPropertyValue('--n'), 10) || 1;
    s.style.setProperty('--i', i);
    s.setAttribute('data-pos', i <= 0 ? 'start' : (i >= n - 1 ? 'end' : 'mid'));
  }
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('[data-mpn-dir]');
    if (a) {
      e.preventDefault(); e.stopPropagation();
      var t = a.parentNode.querySelector('.mpn-track');
      if (t) t.scrollBy({ left: parseInt(a.getAttribute('data-mpn-dir'), 10) * t.clientWidth, behavior: 'smooth' });
      return;
    }
    var f = e.target.closest && e.target.closest('[data-mpn-filter]');
    if (f) {
      e.preventDefault();
      var s = fsummary();
      if (s) { s.focus = function(){ HTMLElement.prototype.focus.call(this, { preventScroll: true }); }; s.click(); }
      return;
    }
    var b = e.target.closest && e.target.closest('[data-mpn-view-btn],[data-mpn-cols-btn]');
    if (!b) return;
    if (b.hasAttribute('data-mpn-view-btn')) {
      d.setAttribute('data-mpn-view', b.getAttribute('data-mpn-view-btn'));
      document.querySelectorAll('.mpn-track').forEach(function(t){ t.scrollLeft = 0; updatePos(t); });
    } else {
      pageChoice = true; auto = false;
      d.setAttribute('data-mpn-cols', b.getAttribute('data-mpn-cols-btn'));
    }
    save(); sync();
  });
  document.addEventListener('change', function(e){ if (e.target && e.target.classList && e.target.classList.contains('facet-filters__sort')) fitSort(); });
  document.addEventListener('scroll', function(e){
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('mpn-track')) return;
    updatePos(t);
  }, true);
  if (desk.addEventListener) desk.addEventListener('change', sync);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSort);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  var timer;
  new MutationObserver(function(){ clearTimeout(timer); timer = setTimeout(sync, 60); }).observe(document.body, { childList: true, subtree: true });
})();
